export const GET_IMAGE_LIST = 'releaseRentalHousing/GET_IMAGE_LIST';
export const UPDATE_HOUSE_BASIC_DATA = 'releaseRentalHousing/UPDATE_HOUSE_BASIC_DATA';
export const UPDATE_RENT_DATA = 'releaseRentalHousing/UPDATE_RENT_DATA';
export const UPDATE_RECORD_DATA = 'releaseRentalHousing/UPDATE_RECORD_DATA';
export const EMPTY_HOUSE_DATA = 'releaseRentalHousing/EMPTY_HOUSE_DATA';
const initialState = {
    propertyRecord:[],
    houseBasicData:{
        nullArr:[],
        negativeArr:[],
        isLoad:0,
        house_type_img:[],
        district_id:'',                             //行政区
        district_title:'',                          //行政区
        plot_id:'',                               //小区名称
        plot_title:'',
        cert_type:'',                               //权属证件类型
        cert_type_title:'',                         //权属证件类型
        cert_no:'',                                 //权属证件编号
        address:'',                                 //房屋坐落
        build_area:'',                              //建筑面积
        house_orientations:'',                      //房屋朝向
        layer_from:'',                              //起始层数
        layer_to:'',                                //终止层
        building_layers_u:'',                       //楼栋地上层数
        bldroom_count:'',                           //室
        hall_count:'',                              //客厅
        toilet_count:'',                            //卫
        kitchen_count:'',                           //厨房
        dialogVisible:false,
        imgSrc:"//breaa-pic-offline-1255419371.picsh.myqcloud.com",
        apply_no:'',
    },
    rentData:{
        isOkTitle:true,
        nullArr:[],
        negativeArr:[],
        decoration_level:'',                        //装修标准
        house_title:'',                              //房源标题'
        warm_type:'',//供暖方式
        equipments:'',//配套设置
        house_description:'',//房屋描述
        traffic_situation:'',//交通情况
        rental_mode:'1',//出租方式
        price_reques:'',//要求月租金
        pay_type_request_mortgage_month:'',
        pay_type_request_pay_month:'',
        bldroom_img:[],//室
        hall_img:[],//客厅
        toilet_img:[],//卫
        kitchen_img:[],//厨
        isLoad1:0,
        isLoad2:0,
        isLoad3:0,
        isLoad4:0,
        imgSrc:"//breaa-pic-offline-1255419371.picsh.myqcloud.com",
    }
};
const houseDataReducer =  (houseBasicData=0, action)=>{
    switch (action.type) {
        case UPDATE_HOUSE_BASIC_DATA:
            return {
                ...houseBasicData,
                    [action.subType]:action.data
            }
        case EMPTY_HOUSE_DATA:
            let obj =    {
            nullArr:[],
              negativeArr:[],
              isLoad:0,
              house_type_img:[],
              district_id:'',                             //行政区
              district_title:'',                          //行政区
              plot_id:'',                               //小区名称
              plot_title:'',
              cert_type:'',                               //权属证件类型
              cert_type_title:'',                         //权属证件类型
              cert_no:'',                                 //权属证件编号
              address:'',                                 //房屋坐落
              build_area:'',                              //建筑面积
              house_orientations:'',                      //房屋朝向
              layer_from:'',                              //起始层数
              layer_to:'',                                //终止层
              building_layers_u:'',                       //楼栋地上层数
              bldroom_count:'',                           //室
              hall_count:'',                              //客厅
              toilet_count:'',                            //卫
              kitchen_count:'',                           //厨房
              dialogVisible:false,
              imgSrc:"//breaa-pic-offline-1255419371.picsh.myqcloud.com",
              apply_no:''
        }
            return obj
        default:
            return houseBasicData
    }
}
const rentDataReducer =  (rentData=0, action)=>{
    switch (action.type) {
        case UPDATE_RENT_DATA:
            return {
                ...rentData,
                [action.subType]:action.data
            }
        default:
            return rentData
    }
}

const propertyRecordReducer =  (propertyRecord=0, action)=>{
    switch (action.type) {
        case UPDATE_RECORD_DATA:
            return action.data
        default:
            return propertyRecord
    }
}

export default (state = initialState, action) => {
    return {
        houseBasicData : houseDataReducer(state.houseBasicData, action),
        rentData : rentDataReducer(state.rentData, action),
        propertyRecord : propertyRecordReducer(state.propertyRecord, action)
    };
}
export const dispatch_func = {
    getImgList : (data) => {
        return dispatch => {
            dispatch({
                type: GET_IMAGE_LIST,
                data:data
            });
        }
    },
    update_houseData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_HOUSE_BASIC_DATA,
                data:data,
                subType:type
            });
        }
    },
    empty_houseData : () => {
        return dispatch => {
            dispatch({
                type: EMPTY_HOUSE_DATA
            });
        }
    },

    update_rentData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_RENT_DATA,
                data:data,
                subType:type
            });
        }
    },
    update_propertyRecord : (data) => {
        return dispatch => {
            dispatch({
                type: UPDATE_RECORD_DATA,
                data:data,
            });
        }
    },



};


// WEBPACK FOOTER //
// ./src/modules/releaseRentalHousing.js